import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import PageShell from "@/components/PageShell";

const ARTICLES = [
  {
    title: "The Rise of the Gig Economy",
    desc: "How independent work reshaped American income — and what it means for financial services.",
    tag: "Industry",
  },
  {
    title: "Financial Challenges Facing Independent Workers",
    desc: "From irregular payouts to expense volatility, the realities of life between deposits.",
    tag: "Research",
  },
  {
    title: "Why Gig Workers Need Better Financial Tools",
    desc: "Traditional banking wasn't built for variable income. Here's what is.",
    tag: "Perspective",
  },
  {
    title: "Building GigAfloat: Our Journey",
    desc: "An honest look at what we're building, why, and the workers shaping it.",
    tag: "Behind the scenes",
  },
  {
    title: "What We're Learning From Gig Workers",
    desc: "Highlights from thousands of waitlist conversations across the country.",
    tag: "Field notes",
  },
];

const Card = ({ a, i }) => (
  <article
    className="rounded-2xl border border-white/8 bg-white/[0.02] p-5 sm:p-6 hover:border-[#00FF88]/25 transition-colors group"
    data-testid={`blog-article-${i}`}
  >
    <div className="flex items-center justify-between mb-3">
      <span className="font-mono-c text-[10px] uppercase tracking-[0.2em] text-[#00FF88]">
        {a.tag}
      </span>
      <span className="inline-flex items-center gap-1 text-[10px] font-mono-c uppercase tracking-widest text-white/40">
        <Clock className="w-3 h-3" />
        Coming soon
      </span>
    </div>
    <h3 className="font-display font-extrabold tracking-tight text-xl mb-2 group-hover:text-[#00FF88] transition-colors">
      {a.title}
    </h3>
    <p className="text-white/55 text-sm leading-relaxed">{a.desc}</p>
  </article>
);

const Blog = () => (
  <PageShell
    eyebrow="// Blog"
    title="GigAfloat Blog"
    subtitle="Insights, updates, stories, and resources for the gig economy."
    testid="blog-page"
    max="960px"
  >
    <div
      className="rounded-2xl border border-[#00FF88]/25 bg-[#00FF88]/5 p-5 mb-10 text-sm text-white/75"
      data-testid="blog-coming-soon"
    >
      <span className="font-mono-c text-[10px] uppercase tracking-[0.2em] text-[#00FF88] mr-2">
        // Coming soon
      </span>
      Full articles are on the way. In the meantime, the lineup below is what we're working on first.
    </div>

    <div className="grid sm:grid-cols-2 gap-4">
      {ARTICLES.map((a, i) => (
        <Card key={a.title} a={a} i={i} />
      ))}
    </div>

    <div className="mt-12 rounded-2xl border border-white/8 bg-white/[0.02] p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <div className="font-mono-c text-[10px] uppercase tracking-[0.2em] text-[#00FF88]">
          // Want first access?
        </div>
        <div className="font-display font-extrabold text-lg mt-1">
          Join the waitlist — we'll email you when new posts drop.
        </div>
      </div>
      <Link
        to="/"
        className="inline-flex items-center gap-2 bg-[#00FF88] text-black font-bold text-sm px-5 py-2.5 rounded-full btn-glow"
        data-testid="blog-cta"
      >
        Join the Waitlist <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </PageShell>
);

export default Blog;
